import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "gamma",
    aws_cognito_region: "us-east-1",
    aws_cognito_identity_pool_id: "us-east-1:f718cfb3-6e45-4a87-b0f7-d313411f0863",
    aws_user_pools_id: "us-east-1_HAQkMJ20m",
    aws_user_pools_web_client_id: "43e9n85ccmdgu8q287r203inu4",
    Auth: {
      identityPoolId: "us-east-1:f718cfb3-6e45-4a87-b0f7-d313411f0863",
      region: "us-east-1",
      userPoolId: "us-east-1_HAQkMJ20m",
      userPoolWebClientId: "43e9n85ccmdgu8q287r203inu4",
    },
    oauth: {
      domain: "whs-safer-gamma-na.auth.us-east-1.amazoncognito.com",
      redirectSignIn: "https://gamma.na.safer.whs.amazon.dev",
      redirectSignOut: "https://gamma.na.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve gamma to "test".
  const stage = "gamma".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
